module.exports = __webpack_public_path__ + "img/custom_boston_01.d2960d56.png";